import React from 'react';
import { FilterSection } from "@/components/ui";

export const SiteVisitControlPanel = ({
  search,
  setSearch,
  filters,
  setFilters,
  onExport,
  isExporting
}) => {
  return (
    <div className="flex flex-col rounded-2xl overflow-hidden bg-white shadow-[0_8px_30px_rgb(0,0,0,0.04)] min-w-0 mb-5">
      <FilterSection
        search={search}
        setSearch={setSearch}
        filters={filters}
        setFilters={setFilters}
        onExport={onExport}
        isExporting={isExporting}
        // statusOptions={[{ value: "site_visit", label: "Site Visit" }]}
        // statusPlaceholder="Site Visit"
      />
    </div>
  );
};
